export const imgHost2 =
  'https://medin.oss-cn-shanghai.aliyuncs.com/file/2025/Haleon/images'
export const imgHost =
  'https://medin.oss-cn-shanghai.aliyuncs.com/2023/07/14/images'
